export const bowie_details = [
    {id: 1, text: "Status", value: "co-owned"},
    {id: 2, text: "DOB", value:"2019-12-25"},
    {id: 3, text: "AKC", value:"SS16446403"},
    {id: 4, text: "Advanced Cardiac", value:"NORMAL AUSC + ECG + ECHO LR-ACA2824/14F-VPI"},
    {id: 5, text: "OFA Hips", value:"EXCELLENT LR-259574E24F-C-VPI"},
    {id: 6, text: "Elbows", value:"NORMAL LR-EL107578F24-C-VPI"},
    {id: 7, text: "Eyes", value:"Cleared NORMAL"},
    {id: 8, text: "Genotype", value:"B/y"},
];